<script setup lang="ts">
import { onMounted } from "vue";
import { useJoinStore } from "@/store";
import HomeHeader from "@/views/home/HomeHeader.vue";
import HomeFooter from "@/views/home/HomeFooter.vue";
import { useRouter } from "vue-router";

const router = useRouter();
const { initJoin } = useJoinStore();

onMounted(initJoin);
</script>

<template>
  <div id="wrap" class="r2playground">
    <home-header />

    <main id="ct">
      <div class="join-total-ccontainer support">
        <div class="join-support-wrap">
          <ul class="nav nav-tabs support-nav">
            <li class="nav-item">
              <router-link to="" class="nav-link">Home</router-link>
            </li>
            <li class="nav-item">
              <router-link to="" class="nav-link active">Sign up</router-link>
            </li>
          </ul>
          <div class="join-title">
            <h1>Sign up</h1>
            <img src="@/assets/home/img/illust-signup.png" alt="" />
          </div>
        </div>
        <div class="signup-contianer">
          <router-view></router-view>
        </div>
      </div>
    </main>

    <home-footer />
  </div>
</template>

<style lang="scss" scoped>
.r2playground {
.join-total-ccontainer {
  display: flex;
  flex-direction: column;
  gap: 80px;
  padding: 20px 0 150px 0;
}
.join-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 120px;
  > h1 {
   font-family: 'Poppins';
   font-weight: 600;
   font-size: 6.667rem;
   margin-bottom: 20px;
 }
}
.join-support-wrap {
}
.signup-contianer {

}
}
</style>
